// export function validatePlate(plate, mode = 'auto') {
//   if (!plate || typeof plate !== 'string') {
//     return { valid: false, type: null };
//   }

//   // 清理输入
//   const p = plate.trim().replace(/\s+/g, '').toUpperCase();

//   // 汉字省份简称列表
//   const province = /(京|津|沪|渝|冀|豫|云|辽|黑|湘|皖|鲁|新|苏|浙|赣|鄂|桂|甘|晋|蒙|陕|吉|闽|贵|粤|青|藏|川|宁|琼)/;

//   // 蓝牌（普通燃油车）：省+字母+5位字母/数字
//   const blueRegex = new RegExp(`^${province.source}[A-Z][A-HJ-NP-Z0-9]{5}$`);

//   // 新能源车牌：省+字母+6位字母/数字
//   const newEnergyRegex = new RegExp(`^${province.source}[A-Z][A-Z0-9]{6}$`);

//   // 模式判断
//   if (mode === 'blue') {
//     const ok = blueRegex.test(p);
//     return { valid: ok, type: ok ? 'blue' : null };
//   }

//   if (mode === 'newEnergy') {
//     const ok = newEnergyRegex.test(p);
//     return { valid: ok, type: ok ? 'newEnergy' : null };
//   }

//   // 自动识别
//   if (blueRegex.test(p)) return { valid: true, type: 'blue' };
//   if (newEnergyRegex.test(p)) return { valid: true, type: 'newEnergy' };

//   return { valid: false, type: null };
// }

export function validatePlate(plate, mode = 'auto') {
  if (!plate || typeof plate !== 'string') {
    return { valid: false, type: null };
  }

  // 清理输入并统一大写
  const p = plate.trim().replace(/\s+/g, '').toUpperCase();

  // 汉字省份简称列表
  const province =
    /(京|津|沪|渝|冀|豫|云|辽|黑|湘|皖|鲁|新|苏|浙|赣|鄂|桂|甘|晋|蒙|陕|吉|闽|贵|粤|青|藏|川|宁|琼|台|港|澳)/;

  // 蓝牌（普通燃油车）：省 + 字母 + 5 位字母/数字
  const blueRegex = new RegExp(`^${province.source}[A-Z][A-HJ-NP-Z0-9]{5}$`);

  // ✅ 蓝牌特殊号：允许最后一位为 “学” 或 “警”
  const blueSpecialRegex = new RegExp(`^${province.source}[A-Z][A-HJ-NP-Z0-9]{4}(学|警)$`);

  // 新能源车牌：省 + 字母 + 6 位字母/数字
  const newEnergyRegex = new RegExp(`^${province.source}[A-Z][A-Z0-9]{6}$`);

  // 模式判断
  if (mode === 'blue') {
    const ok = blueRegex.test(p) || blueSpecialRegex.test(p);
    return { valid: ok, type: ok ? 'blue' : null };
  }

  if (mode === 'newEnergy') {
    const ok = newEnergyRegex.test(p);
    return { valid: ok, type: ok ? 'newEnergy' : null };
  }

  // 自动识别模式
  if (blueRegex.test(p) || blueSpecialRegex.test(p))
    return { valid: true, type: 'blue' };
  if (newEnergyRegex.test(p))
    return { valid: true, type: 'newEnergy' };

  return { valid: false, type: null };
}